// extracted by mini-css-extract-plugin
export default {"carInformationCard":"XLSPHYG90Zd065lPg4C6","heading":"vJNREQ6iiphyUczQ9yUq","subheading":"sVgTXucAwCgPRdwrn4Vk"};